module.exports = __webpack_public_path__ + "static/img/jingyin2.ddcc07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/jingyin2.png
// module id = 4v/j
// module chunks = 24